import { call, put, takeEvery, all } from 'redux-saga/effects';
import {
    getConsensusSummary,
    getConsensusSummaryCompleted,
    postConsensusSummary,
    postConsensusSummaryCompleted,
    postConsensusSummaryFailed,
    getPeerChallenge,
    getPeerChallengeCompleted,
} from './reducer';
import { getConsensusSummaryApi, postConsensusSummaryApi, getPeerChallengeApi } from './api';
import { showErrorToast } from '../../containers/Toast';

const delay = time => new Promise(resolve => setTimeout(resolve, time));

function* getConsensusSummarySaga({
    payload: {
        id,
        status,
        setErrorText,
    },
}) {
    try {
        const response = yield getConsensusSummaryApi(id, status);
        yield put(getConsensusSummaryCompleted(response.data));
    } catch (error) {
        setErrorText('Something went wrong. Please try again later.');
    }
}

function* getPeerChallengeSaga({
    payload: {
        id,
        status,
        setErrorText,
    },
}) {
    try {
        const response = yield getPeerChallengeApi(id, status);
        yield put(getPeerChallengeCompleted(response.data));
    } catch (error) {
        setErrorText('Something went wrong on Peer Challenge. Please try again later!');
    }
}

function* postConsensusSummarySaga({
    payload: {
        consensusSummary,
        setSubmissionStep,
    },
}) {
    try {
        yield postConsensusSummaryApi(consensusSummary);
        yield call(delay, 2000);
        yield put(postConsensusSummaryCompleted(setSubmissionStep));
    } catch (error) {
        if (error?.status !== 500) { // apiSaga handles 500s automatically
            yield put(showErrorToast({ body: 'There was an error submitting, please refresh and try again' }));
        }
        yield put(postConsensusSummaryFailed());
    }
}

export default function* () {
    yield all([
        takeEvery(getConsensusSummary, getConsensusSummarySaga),
        takeEvery(postConsensusSummary, postConsensusSummarySaga),
        takeEvery(getPeerChallenge, getPeerChallengeSaga),
    ]);
}
